import { render, staticRenderFns } from "./AccountDetailAdditionalInformationContent.vue?vue&type=template&id=0caacc8f&scoped=true"
import script from "./AccountDetailAdditionalInformationContent.vue?vue&type=script&lang=js"
export * from "./AccountDetailAdditionalInformationContent.vue?vue&type=script&lang=js"
import style0 from "./AccountDetailAdditionalInformationContent.vue?vue&type=style&index=0&id=0caacc8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caacc8f",
  null
  
)

export default component.exports